import { NctsError } from '../../../../shared/ncts/types'

const HC_INDEX_RE = /^houseConsignment[.[](\d+)/

export function getNctsErrorHouseConsignmentIndex(error: NctsError): number | null {
  const match = HC_INDEX_RE.exec(error.path ?? '')
  return match ? Number(match[1]) : null
}

export function belongsToHouseConsignment(error: NctsError, index: number): boolean {
  return getNctsErrorHouseConsignmentIndex(error) === index
}
